import { runInAction } from "mobx";
import AppStore from "./AppStore";

import Store from "./Store";

import Qualification, { IQualification } from "../models/Qualifications";

export default class QualificationsStore extends Store<IQualification, Qualification> {
    items = new Map<string, Qualification>();

    constructor(store: AppStore) {
        super(store);
        this.store = store;
    }

    load(items: IQualification[] = []) {
        runInAction(() => {
            items.forEach((item) => {
                this.items.set(item.id, new Qualification(this.store, item))
            })
        });
    }
}
